import moment from 'moment-timezone-all'
import React from 'react'

import { relativeToAbsolute } from 'util/date'

import DatePickerView from './DatePickerView'

export const END_DATE = 'END_DATE'
export const START_DATE = 'START_DATE'

export default class DatePicker extends React.PureComponent {
  // Used by constructor so need to be placed ahead of it
  // eslint-disable-next-line react/sort-comp
  initialMonth = () => {
    const { endDate, startDate } = this.props
    const endMonth = endDate.toLocaleDateString('en-US', {
      month: 'numeric',
      year: 'numeric',
    })
    const startMonth = startDate.toLocaleDateString('en-US', {
      month: 'numeric',
      year: 'numeric',
    })
    if (startMonth === endMonth) {
      const returnDate = new Date(startDate)
      returnDate.setMonth(returnDate.getMonth() - 1)
      return returnDate
    }
    const returnDate = new Date(endDate)
    returnDate.setMonth(returnDate.getMonth() - 2)
    return returnDate
  }

  state = {
    month: this.initialMonth(),
  }

  componentWillUnmount() {
    clearTimeout(this.resetMonthTimeout)
  }

  disabledDays = () => {
    const { startOfReports } = this.props
    return {
      before: startOfReports && startOfReports.toDate(),
      after: new Date(),
    }
  }

  doChangeFocus = focusedInput => {
    this.setState({
      focusedInput,
    })
  }

  endDate = () => {
    return this.props.endDate || this.state.endDate
  }

  handleApply = timeframe => {
    const { end, start } =
      typeof timeframe === 'string'
        ? relativeToAbsolute(timeframe)
        : timeframe || {}
    const { pendingEndDate, pendingStartDate } = this.state
    const startDateOrPending = start || pendingStartDate
    const endDateOrPending = end || pendingEndDate
    this.setState({
      endDate: endDateOrPending,
      focusedInput: null,
      pendingEndDate: null,
      pendingStartDate: null,
      startDate: startDateOrPending,
    })
    clearTimeout(this.resetMonthTimeout)
    this.resetMonthTimeout = setTimeout(this.resetMonth, 250) // Give animations a chance to complete

    if (this.props.onApply) {
      if (typeof timeframe === 'string') {
        this.props.onApply(timeframe)
      } else {
        this.props.onApply(moment(startDateOrPending), moment(endDateOrPending))
      }
    }
  }

  handleCancel = () => {
    const { onCancel } = this.props
    this.setState({
      focusedInput: null,
      pendingStartDate: null,
      pendingEndDate: null,
    })
    clearTimeout(this.resetMonthTimeout)
    this.resetMonthTimeout = setTimeout(this.resetMonth, 250) // Give animations a chance to complete
    if (onCancel) onCancel()
  }

  handleDatesChange = () => {}

  handleDateClick = date => {
    if (this.state.focusedInput === END_DATE) {
      const startDate = this.state.pendingStartDate || this.props.startDate
      this.setState({
        focusedInput: startDate >= date ? END_DATE : START_DATE,
        pendingEndDate: date,
        pendingStartDate: startDate > date ? date : startDate,
      })
    } else {
      const endDate = this.state.pendingEndDate || this.props.endDate
      this.setState({
        focusedInput: END_DATE,
        pendingEndDate: endDate < date ? date : endDate,
        pendingStartDate: date,
      })
    }
  }

  handleFocusChange = focusedInput => {
    this.setState({
      focusedInput,
    })
  }

  handleMonthChange = month => {
    this.setState({ month })
  }

  pendingOrEndDate = () => {
    return this.state.pendingEndDate || this.props.endDate
  }

  pendingOrStartDate = () => {
    return this.state.pendingStartDate || this.props.startDate
  }

  resetMonth = () => {
    this.setState({
      month: this.initialMonth(),
    })
  }

  startDate = () => {
    return this.props.startDate || this.state.startDate
  }

  render() {
    return (
      <DatePickerView
        {...this.props}
        disabledDays={this.disabledDays()}
        endDate={this.endDate()}
        focusedInput={
          this.props.focusedInput === undefined
            ? this.state.focusedInput
            : this.props.focusedInput
        }
        month={this.state.month}
        onApply={this.handleApply}
        onCancel={this.handleCancel}
        onDayClick={this.handleDateClick}
        onDatesChange={this.handleDatesChange}
        onFocusChange={this.handleFocusChange}
        onMonthChange={this.handleMonthChange}
        pendingOrEndDate={this.pendingOrEndDate()}
        pendingOrStartDate={this.pendingOrStartDate()}
        closedCount={this.state.closedCount}
        startDate={this.startDate()}
      />
    )
  }
}
